module.exports = __webpack_public_path__ + "img/Anita Uzar.70a4036e.webp";